export default __webpack_public_path__ + "static/media/heavy_horn.010c4061.png";